import React, { useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';

import { TabPanel } from 'shared';

import { CreateShipper } from './createShipper';
import { ViewShipper } from './viewShippers';

function Shippers() {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab id="ViewShippers_Tab" label="View Shippers" value="0" />
                <Tab id="CreateShipper_Tab" label="Create Shipper" value="1" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ViewShipper />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <CreateShipper />
            </TabPanel>
        </Paper>
    );
}

export { Shippers };
